export * from "../../types"

import { omnia } from "@omnia/exports/omnia"

export const {
    arrayMax,
    arrayMin,
    checkEnumValue,
    color,

    soil: {
        colors: soilColors,
        convertAnalysisAttributeToUnit,
        convertMorganToOlsen,
        convertOlsenToMorgan,
        getMorganAttribute,
        getMorganIndexTextFromValue,
        getSoilUnitLabel,
        getSoilUnitOption,
        getSoilUnitOptions,
        plan: {
            infiltrationRateOptions,
            wormTypeOptions
        }
    },

    components,
    convertDatesToJsonUtc,
    convertGeometryToOpenLayers,
    createIndex,
    createLookup,
    createMap,
    CropYear,
    datalayers,
    defineComponent,
    defineDirective,
    doclib,
    fields,
    format,
    getDateString,
    getDistinctValues,
    groupBy,
    isArrayEmpty,
    isDate,
    isDefined,
    isNumber,
    isObject,
    isString,
    isTerraMapLayer,
    isUndefined,
    isUndefinedOrNull,
    labels,
    models,
    numericTextSort,
    omniaResolve,
    OmniaService,
    param,
    range,
    react,
    RoleId,
    selectMany,
    shell,
    soil,
    sortDates,
    setDates,
    utils,

    color: {
        createValuedColorsProvider,
    },

    fields: {
        isFieldViewModel,
        getCropCssColor,
    },

    map: {
        observeOpenlayersObject,
        getBreaks,
        styles: mapStyles,
    },

    datalayers: {
        isMapLayerZone,
        runOnLayersLoaded,
        getLargestZone,
        getRangeFromValue,
        NumericValuesViewer
    },

    react: {
        classes,
        Checkbox,
        FormGroup,
        DropDownMenu,
        MapView,
        useDisableShell
    }

} = omnia


export { MapSelectInteraction3 } from "@omnia/shared/map/selectInteraction3"
export { NumericValueColorProvider } from "@omnia/shared/color/provider"
export { FieldsMap } from "@omnia/shared/fields/map/fieldsMap"
export { Layer } from "@omnia/shared/map/layer"
export { DrawingLayer } from "@omnia/shared/layers/drawing/layer"
export { Datalayer } from "@omnia/shared/layers/datalayer"
export { DatalayersMap } from "@omnia/shared/layers/datalayersMap"
export { DatalayerZone } from "@omnia/shared/layers/datalayerZone"
export { DatalayerViewManagerProvider } from "@omnia/shared/layers/viewManager"
export { DatalayersApiLoaderProvider } from "@omnia/shared/layers/loader"
export { DatalayerFactoryProvider } from "@omnia/shared/layers/datalayerFactory"
export { ZoneTextLocation  } from "@omnia/shared/layers/types"
export { SoilMapView } from "@omnia/shared/soil/mapView"
export { OmniaAppId } from "@omnia/shared/types"
export  { LayerEditMode } from "@omnia/shared/layers/types"
export { SoilUnit } from "@omnia/shared/soil"

export {
    OmniaObjectType,
    OmniaModuleId,
    CropId,
    LayerTypeId,
    MapGeometryType,
    SoilAnalysisType,
    NitrogenAnalysisType,
    OrderInvoice,
    SoilP2O5Method,
    SsmClassId,
    SoilTypeId,
    SubsoilTypeId,
    SoilCategory
} from "@omnia/shared/generated/enums"

